var magicStyles = [".text[data-v-201fb9ab]{text-align:center;margin:0 auto var(--magic-space,16px)}.wrapper[data-v-201fb9ab]{display:grid;grid-template-columns:auto;gap:var(--magic-space,16px)}"];

export default magicStyles;
